// extracted by mini-css-extract-plugin
export var selector = "selector-module--selector--hLjF1";
export var content = "selector-module--content--C+1HL";
export var left = "selector-module--left--m793e";
export var title = "selector-module--title--qIBif";
export var right = "selector-module--right--ttMjI";
export var options = "selector-module--options--5yfeg";
export var dropdown = "selector-module--dropdown--xDhA6";
export var category = "selector-module--category--5s2fl";
export var avatar = "selector-module--avatar--FQEuR";